import styled from "styled-components";

export const StyledContainer = styled.div<{
  isCollapsed: boolean;
  isActive: boolean;
  isError: boolean;
}>`
  position: relative;
  min-height: ${(props) => (props.isCollapsed ? "58px" : "118px")};
  border-radius: 8px;
  margin: 0 -35px;
  align-items: flex-start;
  padding: 0 35px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  padding-bottom: ${(props) => (props.isCollapsed ? "0" : "16px")};
  border: 1px solid transparent;
  max-width: 420px;

  &:hover {
    border: 1px solid
      ${(props) =>
        props.isActive ? "transparent" : "var(--solution-primary-color)"};
    cursor: pointer;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--solution-primary-color);
    opacity: 0.03;
    pointer-events: none;
    border-radius: 8px;
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid var(--solution-primary-color);
    pointer-events: none;
    border-radius: 8px;
    opacity: ${(props) => (props.isActive ? "1" : "0.2")};
  }

  .action-group-title {
    opacity: 0.7;
    display: flex;
    gap: 5px;
  }

  .action-group-name,
  .action-group-name-empty {
    display: inline-block;
  }

  .action-group-name-empty {
    margin-left: 10px;
  }

  &:hover {
    .dots-menu-wrapper {
      opacity: 1;
    }
  }
`;

export const StyledHeader = styled.div<{ isCollapsed: boolean }>`
  min-height: 58px;
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 10px 0;
  margin-bottom: ${(props) => (props.isCollapsed ? "0" : "20px")};

  &:before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--solution-primary-color);
    height: 1px;
    opacity: 0.18;
    display: ${(props) => (props.isCollapsed ? "none" : "block")};
  }

  .action-group-arrow {
    transform: rotate(${(props) => (props.isCollapsed ? "90deg" : "180deg")});
    color: var(--solution-primary-color);
  }
`;

export const StyledDeleteButton = styled.button`
  margin-left: auto;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: transparent;
  transition: background 150ms ease-out, color 150ms ease-out;

  &:hover {
    background: #00000012;
  }
`;

export const StyledHeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledLabel = styled.div`
  padding: 0 9px;
  height: 22px;
  border-radius: 15px;
  background-color: rgba(0, 0, 0, 0.1);
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
`;
